<script>
    import { navigate } from 'svelte-routing';
    import { onMount } from 'svelte';
    import Cart from '../../components/configure/Cart.svelte';
    import Calendar from '../../components/calendar/Calendar.svelte';
    import Preloader from '../../components/Preloader.svelte';
    import { goBack, store, triggerValidation } from '../../Store.svelte';
    import { clientInstallationDates } from '../../clients/PurchaseClient.svelte';
    import { env } from '../../Environment.svelte';

    export let accordionClass = '';

    let isAviableExpressInstalation = false;
    let installationDate = '';
    let installationExpress = $store.purchaseStatus.installationExpress;
    const isSky = $store.requestedServices.isSky;
    const tabsStyle = `--dynamic-rgba: ${isSky ? 'rgba(4, 8, 255, 0.342)' : 'rgba(211, 23, 114, 0.1)'};
                       --dynamic-color: ${isSky ? '#000ff5' : '#d31772'};`;

    function accordionClick(event) {
        event.preventDefault();
        accordionClass == 'accordion--active'
            ? (accordionClass = '')
            : (accordionClass = 'accordion--active');
    }
    onMount(() => {
        if ($store.requestedServices.isSpMovil) {
            navigate('/compra/resumen', { replace: false });
        }
    });

    let nextHandler = () => {
        if (installationExpress) {
            $store.purchaseStatus.installationDate = installationDate;
        }
        const timeExists = availableAppointments.some(
            (appointment) =>
                appointment.schedule === $store.purchaseStatus.installationTime
        );

        if (!timeExists) {
            return;
        }
        let date = $store.purchaseStatus.installationDate;
        let schedule = $store.purchaseStatus.installationTime;
        if (date != '' && schedule != '')
            navigate('/compra/resumen', { replace: false });
    };

    $: dataCalendar = { '': {} };
    $: availableAppointments = [];
    $store.purchaseStatus.installationDate = '';
    $store.purchaseStatus.installationTime = '';
    const responseInstallationDates = clientInstallationDates(
        $store.purchaseStatus.processId
    ).then((response) => {
        isAviableExpressInstalation =
            $store.requestedServices.product.productFamily === 'tv'
                ? false
                : response.activeRtpInstallation;
        let dates = alasql(
            'SELECT requestedShipDate date FROM ? GROUP BY requestedShipDate',
            [response.quotaSchedule]
        );
        installationDate = response.expressInstallationDate;
        dates.forEach((item) => {
            let schedule = alasql(
                "SELECT DISTINCT cvTimeslot schedule FROM ? WHERE requestedShipDate ='" +
                    item.date +
                    "' and cvTimeslot != 'Nocturno Instalacion 17-19'",
                [response.quotaSchedule]
            );
            if (schedule.length > 0) {
                dataCalendar[item.date] = schedule;
                if (
                    $store.purchaseStatus.installationDate == '' &&
                    schedule.length > 0
                ) {
                    $store.purchaseStatus.installationDate = item.date;
                    $store.purchaseStatus.installationTime =
                        schedule[0].schedule;
                }
            }
        });
    });

    store.subscribe((value) => {
        if (dataCalendar != null) {
            availableAppointments =
                dataCalendar[$store.purchaseStatus.installationDate];

            if (
                availableAppointments != undefined &&
                availableAppointments.length > 0
            ) {
                availableAppointments.sort((a, b) => {
                    if (a.schedule < b.schedule) return -1;
                    if (a.schedule > b.schedule) return 1;
                    return 0;
                });
            }
        }
    });

    onMount(() => {
        window.document.dispatchEvent(
            new Event('DOMContentLoaded', {
                bubbles: true,
                cancelable: true,
            })
        );
        $store.settings.location = { progress: 60, step: 3 };
    });

    let clickScheduler = (schl) => {
        $store.purchaseStatus.installationTime = schl;
    };

    let changePrice = () => {
        $store.purchaseStatus.installationExpress = installationExpress;
        if (installationExpress) {
            $store.requestedServices.total += 100;
            $store.requestedServices.totalOriginal += 100;
        } else {
            $store.requestedServices.total -= 100;
            $store.requestedServices.totalOriginal -= 100;
        }
        $store.purchaseStatus.paymentURL = null;
    };

    $: daySelected = $store.purchaseStatus.installationDate;

    function backHandler() {
        let izzimovilPlan = $store.requestedServices.izzimovil.plan;
        if (izzimovilPlan != null && izzimovilPlan.offerId != null) {
            navigate('/compra/entrega', { replace: false });
        } else {
            navigate('/compra/direccion', { replace: false });
        }
    }

    $: {
        if ($goBack) {
            backHandler();
            goBack.set(false);
        }
        if ($triggerValidation) {
            nextHandler();
            triggerValidation.set(false);
        }
    }
</script>

<div>
    {#await responseInstallationDates}
        <div class="pure-g">
            <div class="pure-u-1">
                <div class="text-center">
                    <Preloader
                        status="Estamos buscando la mejor fecha para tu instalación. Un momento, por favor"
                    />
                </div>
            </div>
        </div>
    {:then response}
        <h2 class="text-fs-27 m-b-10 padding-horizontal">
            Selecciona tu fecha y horario de instalación
        </h2>

        <div class="panel">
            <div class="calendar">
                {#if isAviableExpressInstalation}
                    <div class="pure-g m-b-20">
                        <div class="pure-u-3-4">
                            <p class="fw-semibold m-b-0">
                                Instalación Express <span class="primary-text"
                                    >$100</span
                                >
                            </p>
                            <p class="m-b-15">
                                Por $100 más, ofrece a tu cliente instalación al
                                día siguiente
                            </p>
                        </div>
                        <div class="pure-u-1-4 text-right">
                            <span class="checkbox-switch" style={tabsStyle}>
                                <input
                                    type="checkbox"
                                    name="instalacion_express"
                                    id="instalacion_express"
                                    bind:checked={installationExpress}
                                    on:change={changePrice}
                                />
                                <label for="instalacion_express" />
                            </span>
                        </div>
                        <div class="pure-u-1">
                            <hr />
                        </div>
                    </div>
                    {#if installationExpress}
                        <div class="installation-panel m-b-20">
                            <svg class="icon" aria-hidden="true"
                                ><use
                                    xlink:href="/assets/img/icons/symbol-defs.svg#icon-calendar"
                                /></svg
                            >
                            <span>
                                <p class="fw-semibold">Fecha de instalación</p>
                                <p>
                                    {installationDate} (dd/mm/yyyy)
                                </p>
                            </span>
                        </div>
                    {/if}
                {/if}
                {#if !installationExpress}
                    <div class="date-time-row">
                        <div class="container-panel">
                            <div
                                class="installation-panel--transparent date-picker"
                            >
                                <span>
                                    <p>Elige una fecha y un horario</p>
                                </span>
                            </div>
                            <div class="calendar-back">
                                <Calendar {daySelected} {dataCalendar} />
                            </div>
                        </div>

                        {#if availableAppointments != undefined}
                            <div class="time-panel">
                                <div class="hours-list">
                                    {#each Object.entries(availableAppointments) as [key, value]}
                                        <div class="single-appointment">
                                            <div>
                                                <div
                                                    on:click={() => {
                                                        clickScheduler(
                                                            value.schedule
                                                        );
                                                    }}
                                                    on:keypress={() => {
                                                        clickScheduler(
                                                            value.schedule
                                                        );
                                                    }}
                                                    class="pure__button {isSky
                                                        ? 'pure__button--blue-dark-outline'
                                                        : 'pure__button--outline'} {value.schedule ==
                                                    $store.purchaseStatus
                                                        .installationTime
                                                        ? 'active'
                                                        : 'not-selected'}"
                                                >
                                                    {env.installationSchedule[
                                                        value.schedule
                                                    ].time.interval}
                                                </div>
                                            </div>
                                        </div>
                                    {/each}
                                </div>
                            </div>
                        {/if}
                    </div>
                    <div
                        class="d-flex align-items-center justify-content-between m-t-20"
                    >
                        <div
                            class="d-flex align-items-center justify-content-between"
                        >
                            <div
                                class="back-link hidden-back-link"
                                on:click={backHandler}
                                on:keypress={backHandler}
                                role="button"
                                tabindex="0"
                            >
                                <svg class="icon" aria-hidden="true"
                                    ><use
                                        xlink:href="/assets/img/icons/symbol-defs.svg#icon-arrow-left"
                                    /></svg
                                >
                                <span class="back-span">atrás</span>
                            </div>
                        </div>
                        <div
                            on:click={nextHandler}
                            on:keypress={nextHandler}
                            class="pure__button pure__button--base button-hide"
                        >
                            Continuar
                        </div>
                    </div>
                {:else}
                    <div class="calendar-indications">
                        <div class="appointments-list">
                            <div class="single-appointment">
                                <div>
                                    <div
                                        on:click={() => {
                                            clickScheduler(
                                                'Matutino Instalacion 9-14'
                                            );
                                        }}
                                        on:keypress={() => {
                                            clickScheduler(
                                                'Matutino Instalacion 9-14'
                                            );
                                        }}
                                        class="pure__button {isSky
                                            ? 'pure__button--blue-dark-outline'
                                            : 'pure__button--outline'} {'Matutino Instalacion 9-14' ==
                                        $store.purchaseStatus.installationTime
                                            ? 'active'
                                            : ''}"
                                    >
                                        {env.installationSchedule[
                                            'Matutino Instalacion 9-14'
                                        ].time.interval}
                                    </div>
                                </div>
                            </div>
                            <div class="single-appointment">
                                <div>
                                    <div
                                        on:click={() => {
                                            clickScheduler(
                                                'Vespertino Instalacion 14-18'
                                            );
                                        }}
                                        on:keypress={() => {
                                            clickScheduler(
                                                'Vespertino Instalacion 14-18'
                                            );
                                        }}
                                        class="pure__button {isSky
                                            ? 'pure__button--blue-dark-outline'
                                            : 'pure__button--outline'} {'Vespertino Instalacion 14-18' ==
                                        $store.purchaseStatus.installationTime
                                            ? 'active'
                                            : ''}"
                                    >
                                        {env.installationSchedule[
                                            'Vespertino Instalacion 14-18'
                                        ].time.interval}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                {/if}
            </div>
        </div>
    {/await}
</div>

<style>
    .appointments-list {
        display: flex;
        justify-content: center;
        width: 100%;
    }
    .single-appointment {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin: 0px 0px 16px;
    }
    .calendar-back {
        background: #f5f6f8;
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        border-radius: 8px;
        padding: 24px 16px;
        overflow-x: hidden;
    }
    .calendar-indications {
        display: flex;
        align-items: center;
        padding-top: 24px;
        text-align: left;
        /* border: solid 1px; */
        width: 100%;
    }
    .date-picker {
        margin-bottom: 12px;
        margin-top: 32px;
        font-weight: 600;
    }
    .not-selected {
        border: 1px solid black !important;
        color: black !important;
    }
    .not-selected:hover {
        border: 1px solid #d31772 !important;
        border-color: #a4abaf !important;
        background-color: #d31772 !important;
        color: #fff !important;
    }
    .back-link {
        display: flex;
        align-items: center;
        cursor: pointer;
    }
    .time-panel {
        display: flex;
        flex-direction: column;
        flex-wrap: wrap;
        justify-content: center;
    }
    .date-time-row {
        display: flex;
        flex-direction: row;
        align-items: start;
        gap: 20px;
        max-width: 100%;
    }
    .back-span {
        padding: 24px;
        font-weight: 600;
    }
    .hours-list {
        display: flex;
        flex-direction: column;
        gap: 15px;
        margin-top: 85px;

        @media (max-width: 767px) {
            flex-direction: row;
            margin-top: 0;
        }
    }

    @media (max-width: 767px) {
        .date-time-row {
            flex-direction: column;
        }

        .time-panel {
            width: 100%;
        }

        .container-panel {
            width: 100%;
            flex-grow: 1;
        }

        .hours-list {
            width: 100%;
        }

        .single-appointment {
            width: 100%;
        }

        .single-appointment div {
            width: 100%;
        }

        .pure__button {
            width: 100%;
            margin-bottom: 8px;
        }
        .text-fs-26 {
            text-align: center;
            margin-left: auto;
            font-size: 18px;
        }
        .time-panel {
            justify-content: center;
            width: 100%;
        }
    }

    @media (min-width: 767px) {
        .calendar-back {
            padding: 32px 70px;
        }
    }
</style>
